/**
 * Controller: OrdersRefundConfirmModal
 */
angular.module('acme.view.application.orders.refund.confirmModal.controllers', [])
.controller('OrdersRefundConfirmModalController', [ '$scope', '$uibModalInstance', 'currentRefund', function ($scope, $uibModalInstance, currentRefund) {

    $scope.errors = [];

    $scope.model = currentRefund;

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);